import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logotiposplash from "../../../images/logosinestry.png";
import Configuracion from "../../../data/configuracion";
import apibig from "../../../components/Apibig";
import DynamicIcon from "../../../components/DynamicIcon";


// SplashMenu multinivel con control por niveles del submenu abierto
const SplashMenu = ({
  menus,
  nivel = 0,
  openSubmenus,
  setOpenSubmenus,
  parentKey = "root", // clave identificadora del padre (para niveles)
}) => {
  const hasChildren = menus.menus && menus.menus.length > 0;
  const submenuKey = menus.clave || menus.Titulo || `submenu-${nivel}`;

  // Qué submenu está abierto en este nivel (identificado por parentKey)
  const openKeyAtLevel = openSubmenus[parentKey];
  const isOpen = openKeyAtLevel === submenuKey;

  const toggleSubmenu = (e) => {
    e.preventDefault();
    setOpenSubmenus((prev) => {
      // Si ya está abierto, cerrar
      if (prev[parentKey] === submenuKey) {
        const copy = { ...prev };
        delete copy[parentKey];
        // También cerramos subniveles hijos (para evitar que queden abiertos)
        // Lo podemos hacer limpiando claves cuyo padre sea submenuKey
        Object.keys(copy).forEach((key) => {
          if (key.startsWith(submenuKey)) delete copy[key];
        });
        return copy;
      } else {
        // Abrimos este submenu y cerramos otros hermanos en el mismo nivel
        return { ...prev, [parentKey]: submenuKey };
      }
    });
  };

  return (
    <div style={{ paddingLeft: nivel * 20 }} className="py-1">
      <div
        className="flex justify-between items-center cursor-pointer text-blue-800 hover:text-white hover:bg-sidebar-100 rounded-md p-1"
        onClick={hasChildren ? toggleSubmenu : undefined}
      >
        {menus.URL ? (          
          <a
            href={menus.id!=59 ? '#/'+menus.Ruta : menus.Ruta}          
            target={menus.id==59 ? "_blank" : "_self"}
            rel="noopener noreferrer"
            className="flex items-center w-full"
            onClick={(e) => hasChildren && e.preventDefault()}
          >
            {menus.Icono && (
              <span className="mr-2">
                <DynamicIcon iconName={menus.Icono} size="1rem" />
              </span>
            )}
            {menus.Titulo}
          </a>
        ) : (
          <Link to={menus.Ruta || "#"} className="flex items-center w-full">
            {menus.Icono && (
              <span className="mr-2">
                <DynamicIcon iconName={menus.Icono} size="1rem" />
              </span>
            )}
            {menus.Titulo}
          </Link>
        )}

        {hasChildren && (
          <span className="ml-2 select-none text-sm">{isOpen ? "▲" : "▼"}</span>
        )}
      </div>

      {hasChildren && isOpen && (
        <div className="border-l border-gray-300 mt-1">
          {menus.menus.map((submenu, idx) => (
            <SplashMenu
              key={submenu.clave || idx}
              menus={submenu}
              nivel={nivel + 1}
              openSubmenus={openSubmenus}
              setOpenSubmenus={setOpenSubmenus}
              parentKey={submenuKey} // paso la clave del submenu como padre del siguiente nivel
            />
          ))}
        </div>
      )}
    </div>
  );
};

const Menuprincipal = ({ menu }) => {
  const [openClave, setOpenClave] = useState(null);
  const [openSubmenus, setOpenSubmenus] = useState({}); // objeto para submenu abierto por nivel

  const toggleMainMenu = (clave) => {
    if (openClave === clave) {
      setOpenClave(null);
      setOpenSubmenus({});
    } else {
      setOpenClave(clave);
      setOpenSubmenus({});
    }
  };

  if (menu.menus?.length > 0) {
    return (
      <div>
        <div
         
          className={`cursor-pointer flex justify-between bg-menusplash-200 text-white rounded-[23rem] h-[2rem] px-6 hover:hover:bg-menusplash-100  transition font-semibold text-[1rem] w-full ${
            openClave === menu.clave ? "bg-menusplash-100" : "bg-menusplash-200"
          }`}
        >
          <div  onClick={() => toggleMainMenu(menu.clave)} className="flex justify-center items-center">
            <DynamicIcon iconName={menu.Icono} />
            <span className="ml-2">{menu.Titulo}</span>
            {menu.menus?.length > 0 && (
              <span className="ml-2 text-xs">
                {openClave === menu.clave ? "▲" : "▼"}
              </span>
            )}
          </div>
        </div>

        {openClave === menu.clave && (
          <ul
            className="absolute flex flex-col justify-start z-50 ml-[1rem] bg-menusplash-300 text-black  rounded-md shadow-lg w-[20rem] min-h-auto overflow-auto p-1"
            key={`submenu-${menu.clave}`}
          >
            {menu.menus.map((submenu, index) => (
              <li key={submenu.clave || index}>
                <SplashMenu
                  menus={submenu}
                  openSubmenus={openSubmenus}
                  setOpenSubmenus={setOpenSubmenus}
                  parentKey={menu.clave} // nivel 1 identificado por clave del menú principal
                />
              </li>
            ))}
          </ul>
        )}

        
      </div>
    );
  } else {
    // Menú sin submenús
    
    return (
     
      <div
        className={`cursor-pointer flex justify-center bg-menusplash-200 text-white rounded-[23rem] h-[2rem] px-6 hover:bg-menusplash-100 transition font-semibold text-[1rem] w-full ${
          openClave === menu.clave ? "bg-menusplash-100" : "bg-menusplash-200"
        }`}
      >
       <Link
  className="w-full ml-2 flex justify-center items-center"
  to={menu.Win ? menu.URL : menu.Ruta}
  target={menu.Win ? "_blank" : undefined}
  rel={menu.Win ? "noopener noreferrer" : undefined}
>
  <DynamicIcon iconName={menu.Icono} />
  <span className="w-full ml-2">{menu.Titulo}</span>
</Link>

      </div>
    );
  }
};

const Splash = ({ autusuario, permisos }) => {
  const [datapermisos, setDatapermisos] = useState(permisos.permisos || []);
  const [openClave, setOpenClave] = useState(null);

  useEffect(() => {
    const fetchroles = async () => {
      try {
        const proyecto = Configuracion.proyecto;
        const emailusuario = autusuario.email;
        const basedatos = Configuracion.basedatos;
        const response = await apibig.post("/api/permisos/getpermisosxusuario", {
          appid: proyecto,
          email: emailusuario,
          basedatos,
        });
        sessionStorage.setItem("data", JSON.stringify(response.data));
        const cnt = JSON.parse(sessionStorage.getItem("data"));
        setDatapermisos(cnt.permisos);
      } catch (error) {
        console.error("Error al obtener permisos:", error);
      }
    };
    fetchroles();
  }, [autusuario]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 items-center justify-center p-4">
      <div className="w-[90%] max-w-screen-xl bg-white rounded-[2vw] shadow-xl p-6 space-y-6 my-10">
        {/* Logo y bienvenida */}
        <div className="flex flex-col items-center">
          <img src={logotiposplash} className="w-[14rem]" alt="logo" />
          <h1 className="text-2xl font-bold text-center text-titulo1splash-100 mt-2">
            Bienvenido a siniestrosApp
          </h1>
          <p className="sm:block text-center text-sm text-titulo2splash-100 mt-2 max-w-3xl">
            Aquí encontrarás la administración para la operación de la cuenta, como informes,
            estadísticas, operación y capacitación, para mantener un alto estándar de calidad.
          </p>
        </div>
 
        {/* Menús principales */}
        <div className="h-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1">
          {datapermisos.map((menu, index) => (
            <Menuprincipal key={menu.clave || index} menu={menu} />
          ))}
       

 
        </div>
      </div>
    </div>
  );
};

export default Splash;
